<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="mx-auto px-2 pt-2">
            <!-- <v-btn @click="test">test</v-btn> -->
            <v-toolbar flat dark class="indigo lighten-3">
                <v-toolbar-title>Correct Container Info</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-breadcrumbs :items="$store.state.routes" divider=" | "></v-breadcrumbs>
                <v-row>
                    <v-col cols="3">
                        <v-text-field
                            v-model="container_number"
                            prepend-inner-icon="mdi-train-car-container"
                            label="Wrong Container Number..."
                            placeholder="Wrong Container Number..."
                            outlined
                            dense
                            @keyup="getWrongContainerInfo()"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-simple-table dark dense>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">
                                    container_number
                                </th>
                                <th class="text-left">
                                    transaction_id
                                </th>
                                <th class="text-left">
                                    shipping_line
                                </th>
                                <th class="text-left">
                                    container_class
                                </th>
                                <th class="text-left">
                                    container_type
                                </th>
                                <th class="text-left">
                                    contaiher_size
                                </th>
                                <th class="text-left">
                                    created_at
                                </th>
                                <th class="text-left">
                                    updated_at
                                </th>
                                <th class="text-left">
                                    actions
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="t in transactions"
                                >
                                    <td>{{ t.container_number }}</td>
                                    <td>{{ t.transaction_id }}</td>
                                    <td>{{ t.company.name }}</td>
                                    <td>{{ t.class.class }}</td>
                                    <td>{{ t.type.type }}</td>
                                    <td>{{ t.size.size }}</td>
                                    <td>{{ t.created_at | formatDate }}</td>
                                    <td>{{ t.updated_at | formatDate }}</td>
                                    <td>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">                                        
                                                <v-icon 
                                                    v-on="on" 
                                                    color="orange"
                                                    @click="openEditContainerInformationDialog(t)"
                                                >mdi-pencil</v-icon>
                                            </template>
                                            <span>Edit ContainerInfo</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>                                                  
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!--encodeContainerInformationDialog start-->
        <v-dialog v-model="encodeContainerInformationDialog" fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card flat>
                <v-container fluid>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title>
                            Encode Container Information --{{ container_number }}--
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                          icon
                          dark
                          @click="encodeContainerInformationDialog = false"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                            <v-row>
                                <v-col cols="6">
                                    <v-select
                                        outlined
                                        dense
                                        label="Company"
                                        placeholder="Company"
                                        :items="companies"
                                        item-text="name"
                                        item-value="company_id"
                                        v-model="editCompany"
                                        :rules="rules"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6">
                                    <v-select
                                        outlined
                                        dense
                                        label="ContainerClass"
                                        placeholder="ContainerClass"
                                        :items="containerClasses"
                                        item-text="class"
                                        item-value="container_class_id"
                                        v-model="editContainerClass"
                                        :rules="rules"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-select
                                        outlined
                                        dense
                                        label="ContainerType"
                                        placeholder="ContainerType"
                                        :items="containerTypes"
                                        item-text="type"
                                        item-value="container_type_id"
                                        v-model="editContainerType"
                                        :rules="rules"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6">
                                    <v-select
                                        outlined
                                        dense
                                        label="ContainerSize"
                                        placeholder="ContainerSize"
                                        :items="containerSizes"
                                        item-text="size"
                                        item-value="container_size_id"
                                        v-model="editContainerSize"
                                        :rules="rules"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn 
                                        block 
                                        color="red" 
                                        class="lighten-3" 
                                        dark
                                        @click="updateContainerInformation()"
                                    >Update Container Information</v-btn>
                                </v-col>
                            </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
        <!--encodeContainerInformationDialog finish-->
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            container_number: '',
            transactions: '',
            encodeContainerInformationDialog: false,
            editContainerType: null,
            editContainerClass: null,
            editContainerSize: null,
            editCompany: null,
            companies: [],
            containerClasses: [],
            containerTypes: [],
            containerSizes: [],
            rules: [(v) => !!v || "Required"],
        }
    },
    mounted() {
        if( !this.$store.state.user.role.match(/^su$|admin|ec/) ) {
            alert('You have not access right to enter the area...');
            this.$router.push('/');
        }

        if( !this.$store.state.routes.some(obj => obj.href == this.$route.path) ) {
            this.$store.commit(
                'addRoute',
                {
                    text: this.$route.path,
                    disabled: false,
                    href: this.$route.path,                
                }            
            );
        }         
    },
    methods: {
        getWrongContainerInfo: function() {

            if( !this.container_number.match(/^[A-Z]{4}[0-9]{7}$/)) {
                this.transactions = [];
                return false;
            }

            this.overlay = true;
            axios.post(
                '/api/get_wrong_container_info',
                {
                    container_number: this.container_number
                }
            ).then(response => {
                // console.log(response.data);
                if( response.status === 200 ) {
                    this.transactions = response.data;
                }
            }).finally(() => {
                this.overlay = false;
            });
        },
        openEditContainerInformationDialog: function(item) {
            // console.log(item)
            this.encodeContainerInformationDialog = true;
            this.editCompany = item.company.company_id;
            this.editContainerClass = item.class.container_class_id;
            this.editContainerSize = item.size.container_size_id;
            this.editContainerType = item.type.container_type_id;
            this.getCompanies();
            this.getContainerClasses();
            this.getContainerTypes();
            this.getContainerSizes();
        },
        getCompanies: function() {
            axios.post('/api/get_companies')
                .then(response => {
                    this.companies = response.data;
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    
                });
        },
        getContainerSizes: function() {
            axios.post('/api/get_container_sizes')
                .then(response => {
                    this.containerSizes = response.data;
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    
                });
        },
        getContainerTypes: function() {
            axios.post('/api/get_container_types')
                .then(response => {
                    this.containerTypes = response.data;
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    
                });
        },
        getContainerClasses: function() {
            axios.post('/api/get_container_classes')
                .then(response => {
                    this.containerClasses = response.data;
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    
                });
        },
        updateContainerInformation: function() {
            if (!this.$refs.form.validate()) {
                return false;
            }

            if ( !confirm('Is it ok to update the transaction record?') ) {
                return false;
            }

            this.overlay = true;
            axios.post(
                '/api/update_container_information',
                {
                    container_number: this.container_number,
                    company_id: this.editCompany,
                    container_class_id: this.editContainerClass,
                    container_type_id: this.editContainerType,
                    container_size_id: this.editContainerSize,
                }
            ).then(response => {
                console.log(response.data);
                this.encodeContainerInformationDialog = false;
                this.getWrongContainerInfo();
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
            });
        }
    },
    filters: {
        formatDate: function (date) {
            return date !== null ? moment(date).format("MM-DD-YYYY hh:mm:ss A") : '';
        },
    }
}
</script>